// offerSlice.ts
import { Offer } from '../types/offerForm';
import createGenericSlice from './createGenericSlice';

const offerSlice = createGenericSlice<Offer>('offers');

export const { addItem, editItem, deleteItem, copyItem, clearItems} = offerSlice.actions;

export default offerSlice.reducer;
